import { FC, ReactNode } from "react"

const Button: FC<{
    children: ReactNode,
    className?:string,
    onClick?: VoidFunction,
}> = (props) => {
    return <button {...props} className={`rounded-md bg-primary/80 text-white px-4 py-2 text-sm hover:bg-primary ${props?.className}`} >
        {props?.children}
    </button>
}

export default Button;